import { httpClient } from './httpClient';

/**
 * POST連携トークンから会員ID情報を取得
 * @param {string} token - linkage_token
 * @returns {Promise<{member_id: string, price_id: string, company_id: number}>}
 */
export const getLinkageToken = async (token) => {
  const response = await httpClient.get(`/linkage/token/${token}`);
  return response.data;
};
